export const avatarsCommonUrls = {
  avatarFilePrefix: '/papi/avatars/file',
  avatarsPrefix: '/papi/avatars',
} as const;

export const iconsCommonUrls = {
  iconFilePrefix: '/papi/icons/file',
  iconsPrefix: '/papi/icons',
} as const;

export const mediaCommonUrls = {
  mediaFilePrefix: '/papi/media/file',
  mediaPrefix: '/papi/media',
} as const;
